<template>
  <footer class="footer">
  <div class="has-text-centered">
    <ul class="is-flex is-justify-content-center">
      <li class="">
        <a href="https://twitter.com/twitter"><img src="../assets/image/footer_icon_twitter.png" width="36" height="36" alt="twitter"></a>
      </li>
      <li class="ml-3">
        <a href="https://www.facebook.com/facebook"><img src="../assets/image/footer_icon_facebook.png" width="36" height="36" alt="facebook"></a>
      </li>
      <li class="ml-3">
        <a href="https://www.linebiz.com/jp/"><img src="../assets/image/footer_icon_line.png" width="36" height="36" alt="line"></a>
      </li>
    </ul>
    <ul class="footer__nav columns is-variable is-0 is-multiline is-mobile mt-2">
      <li class="column is-2-desktop is-offset-2-desktop is-half-mobile has-text-left-touch">
        <router-link to="/user-policy">利用規約</router-link>
      </li>
      <li class="column is-2-desktop is-half-touch has-text-left-touch">
        <router-link to="/specific-trade-law">特定商取引法に基づく表記</router-link>
      </li>
      <li class="column is-2-desktop is-half-touch has-text-left-touch">
        <router-link to="/contact-us">お問い合わせ</router-link>
      </li>
      <li class="column is-2-desktop is-half-touch has-text-left-touch">
        <a href="#">運営会社</a>
      </li>
    </ul>
    <p class="footer__copyright">©︎ 2021 pandra</p>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style scoped>

</style>
